import React from 'react'
import { withIcon } from '../../withIcon'

function YandexIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.33766 5.81347C7.38505 6.61443 6.88179 7.75914 6.88179 9.16923C6.88179 10.3084 7.16092 11.1904 7.67689 11.9615C8.20092 12.7447 8.98727 13.4407 10.0478 14.1732L10.4604 14.4582L6.95636 19.5H8.84645L12.5882 14.0725L11.5644 13.4042C11.5642 13.4041 11.5647 13.4044 11.5644 13.4042C10.6739 12.8271 9.95064 12.2746 9.45877 11.5848C8.95289 10.8753 8.71815 10.0606 8.71815 9.01099C8.71815 8.02832 9.07979 7.16714 9.81354 6.56161C10.5354 5.96592 11.5621 5.66264 12.8182 5.66264H14.6091V19.5H16.4818V4.5H12.8C10.7776 4.5 9.30052 5.00388 8.33766 5.81347ZM17 20V20.5H13.6091V14.3534L9.37167 20.5H5.04358L9.07055 14.7057C8.15194 14.034 7.39257 13.3348 6.84578 12.5176C6.21175 11.57 5.88179 10.4916 5.88179 9.16923C5.88179 7.5024 6.48762 6.06249 7.6941 5.04807C8.89032 4.04227 10.6224 3.5 12.8 3.5H17.4818V20H17ZM13.6091 13.5447V6.66264H12.8182C11.7106 6.66264 10.9373 6.93079 10.45 7.33289C9.97469 7.72517 9.71815 8.28817 9.71815 9.01099C9.71815 9.89542 9.91069 10.4961 10.273 11.0042C10.6492 11.5318 11.2354 11.9994 12.1082 12.565L12.1096 12.5659L13.6091 13.5447Z" fill={color}/>
    </svg>
  )
}

export default withIcon(YandexIcon)
